import { render, staticRenderFns } from "./ClinicianProgramForm.vue?vue&type=template&id=39d8dc5e"
import script from "./ClinicianProgramForm.vue?vue&type=script&lang=js"
export * from "./ClinicianProgramForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports